//actions api declaration
import { fork } from 'redux-saga/effects';
import auth from './auth';
//import wall from './wall';
import widget from './widget';
import integration from './integration';
import reviews from './reviews';
import posts from './posts';
import profile from './profile';
import master from './master';
import billing from './billing';
import activity from './activity';
import visitor from './visitor';
import instaFeed from './instaFeed';

export default function* rootSaga() {
  yield [
    fork(auth),
    //fork(wall),
    fork(integration),
    fork(reviews),
    fork(posts),
    fork(profile),
    fork(master),
    fork(widget),
    fork(billing),
    fork(activity),
    fork(visitor),
    fork(instaFeed)
  ];
}



// WEBPACK FOOTER //
// ./src/sagas/index.js